import { useApiQuery } from "app/modules/api-client";
import type { AdIntelligenceController } from "app/pages/digital-marketing/ad-intelligence/common/shared/types/types";
import { chosenSites } from "app/common/services/chosenSites";
import DurationService, { BasicDurations } from "app/services/DurationService";

import { useDisplayAdvertiserPublisherDataAndParams } from "../../hooks/useDisplayAdvertiserPublisherDataAndParams";

export const useFilteredEntities = (controller: AdIntelligenceController, searchTerm?: string, enabled = true) => {
    const params = useDisplayAdvertiserPublisherDataAndParams();
    const selectedSite = params.adsSelectedSite ?? chosenSites.getPrimarySite().name;
    const { from, to, isWindow } = DurationService.getDurationData(params.duration).forAPI;

    const methodName =
        controller === "advertiser"
            ? "adIntelligenceAdvertiserAdsGalleryUnifiedFilteredPublishersList"
            : "adIntelligencePublisherAdsGalleryUnifiedFilteredAdvertisersList";

    const { data, isLoading, isError } = useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName,
            options: {
                enabled,
            },
        },
        {
            key: [selectedSite],
            country: params.country,
            from,
            to,
            isWindow,
            latest: isWindow ? BasicDurations.LAST_TWENTY_EIGHT_DAYS : undefined,
            includeTerms: searchTerm || undefined,
        },
    );

    return {
        data: data ?? [],
        isLoading,
        isError,
    };
};
